// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.company-selection-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.company-selection-modal {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 600px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}
.company-selection-modal .modal-header {
  padding: 20px 24px;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.company-selection-modal .modal-header h2 {
  margin: 0;
  color: #333;
  font-size: 1.5rem;
  font-weight: 600;
}
.company-selection-modal .modal-header .close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  transition: color 0.2s ease;
  padding: 4px 8px;
  border-radius: 4px;
}
.company-selection-modal .modal-header .close-btn:hover {
  color: #333;
  background-color: #f5f5f5;
}
.company-selection-modal .modal-body {
  padding: 20px 24px;
  flex: 1 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.company-selection-modal .modal-body .search-container {
  margin-bottom: 20px;
}
.company-selection-modal .modal-body .search-container .search-input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  transition: border-color 0.2s ease;
}
.company-selection-modal .modal-body .search-container .search-input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}
.company-selection-modal .modal-body .search-container .search-input::placeholder {
  color: #999;
}
.company-selection-modal .modal-body .loading, .company-selection-modal .modal-body .error {
  text-align: center;
  padding: 40px 20px;
  font-size: 14px;
}
.company-selection-modal .modal-body .loading {
  color: #666;
}
.company-selection-modal .modal-body .error {
  color: #dc3545;
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  border-radius: 6px;
}
.company-selection-modal .modal-body .companies-list {
  flex: 1 1;
  overflow-y: auto;
  margin: -8px;
}
.company-selection-modal .modal-body .companies-list .no-companies {
  text-align: center;
  padding: 40px 20px;
  color: #666;
  font-size: 14px;
}
.company-selection-modal .modal-body .companies-list .company-item {
  margin: 8px;
  padding: 16px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.company-selection-modal .modal-body .companies-list .company-item:hover {
  border-color: #007bff;
  background-color: #f8f9ff;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.15);
}
.company-selection-modal .modal-body .companies-list .company-item:active {
  transform: translateY(0);
  box-shadow: 0 1px 4px rgba(0, 123, 255, 0.2);
}
.company-selection-modal .modal-body .companies-list .company-item .company-info {
  flex: 1 1;
}
.company-selection-modal .modal-body .companies-list .company-item .company-info .company-name {
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  transition: color 0.2s ease;
}
.company-selection-modal .modal-body .companies-list .company-item .company-info .company-email {
  margin: 0 0 4px 0;
  font-size: 14px;
  color: #666;
}
.company-selection-modal .modal-body .companies-list .company-item .company-info .contact-person {
  margin: 0;
  font-size: 13px;
  color: #888;
}
.company-selection-modal .modal-body .companies-list .company-item:hover .company-info .company-name {
  color: #007bff;
}

@media (max-width: 768px) {
  .company-selection-modal {
    width: 95%;
    max-height: 85vh;
  }
  .company-selection-modal .modal-header {
    padding: 16px 20px;
  }
  .company-selection-modal .modal-header h2 {
    font-size: 1.3rem;
  }
  .company-selection-modal .modal-body {
    padding: 16px 20px;
  }
  .company-selection-modal .modal-body .company-item {
    padding: 16px;
    margin: 6px;
  }
  .company-selection-modal .modal-body .company-item .company-info .company-name {
    font-size: 15px;
  }
  .company-selection-modal .modal-body .company-item .company-info .company-email {
    font-size: 13px;
  }
  .company-selection-modal .modal-body .company-item .company-info .contact-person {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/CompanySelectionModal/CompanySelectionModal.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AACF;;AAEA;EACE,iBAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,0CAAA;AACF;AACE;EACE,kBAAA;EACA,gCAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AACJ;AACI;EACE,SAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;AACN;AAEI;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;AAAN;AAEM;EACE,WAAA;EACA,yBAAA;AAAR;AAKE;EACE,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAHJ;AAKI;EACE,mBAAA;AAHN;AAKM;EACE,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,kCAAA;AAHR;AAKQ;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAHV;AAMQ;EACE,WAAA;AAJV;AASI;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;AAPN;AAUI;EACE,WAAA;AARN;AAWI;EACE,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;AATN;AAYI;EACE,SAAA;EACA,gBAAA;EACA,YAAA;AAVN;AAYM;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AAVR;AAaM;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAXR;AAaQ;EACE,qBAAA;EACA,yBAAA;EACA,2BAAA;EACA,6CAAA;AAXV;AAcQ;EACE,wBAAA;EACA,4CAAA;AAZV;AAeQ;EACE,SAAA;AAbV;AAeU;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,2BAAA;AAbZ;AAgBU;EACE,iBAAA;EACA,eAAA;EACA,WAAA;AAdZ;AAiBU;EACE,SAAA;EACA,eAAA;EACA,WAAA;AAfZ;AAmBQ;EACE,cAAA;AAjBV;;AAyBA;EACE;IACE,UAAA;IACA,gBAAA;EAtBF;EAwBE;IACE,kBAAA;EAtBJ;EAwBI;IACE,iBAAA;EAtBN;EA0BE;IACE,kBAAA;EAxBJ;EA0BI;IACE,aAAA;IACA,WAAA;EAxBN;EA2BQ;IACE,eAAA;EAzBV;EA4BQ;IACE,eAAA;EA1BV;EA6BQ;IACE,eAAA;EA3BV;AACF","sourcesContent":[".company-selection-modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.company-selection-modal {\r\n  background: white;\r\n  border-radius: 12px;\r\n  width: 90%;\r\n  max-width: 600px;\r\n  max-height: 80vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\r\n\r\n  .modal-header {\r\n    padding: 20px 24px;\r\n    border-bottom: 1px solid #e0e0e0;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n\r\n    h2 {\r\n      margin: 0;\r\n      color: #333;\r\n      font-size: 1.5rem;\r\n      font-weight: 600;\r\n    }\r\n\r\n    .close-btn {\r\n      background: none;\r\n      border: none;\r\n      font-size: 24px;\r\n      cursor: pointer;\r\n      color: #666;\r\n      transition: color 0.2s ease;\r\n      padding: 4px 8px;\r\n      border-radius: 4px;\r\n\r\n      &:hover {\r\n        color: #333;\r\n        background-color: #f5f5f5;\r\n      }\r\n    }\r\n  }\r\n\r\n  .modal-body {\r\n    padding: 20px 24px;\r\n    flex: 1;\r\n    overflow: hidden;\r\n    display: flex;\r\n    flex-direction: column;\r\n\r\n    .search-container {\r\n      margin-bottom: 20px;\r\n\r\n      .search-input {\r\n        width: 100%;\r\n        padding: 12px 16px;\r\n        border: 1px solid #ddd;\r\n        border-radius: 8px;\r\n        font-size: 14px;\r\n        transition: border-color 0.2s ease;\r\n\r\n        &:focus {\r\n          outline: none;\r\n          border-color: #007bff;\r\n          box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\r\n        }\r\n\r\n        &::placeholder {\r\n          color: #999;\r\n        }\r\n      }\r\n    }\r\n\r\n    .loading, .error {\r\n      text-align: center;\r\n      padding: 40px 20px;\r\n      font-size: 14px;\r\n    }\r\n\r\n    .loading {\r\n      color: #666;\r\n    }\r\n\r\n    .error {\r\n      color: #dc3545;\r\n      background-color: #f8d7da;\r\n      border: 1px solid #f5c6cb;\r\n      border-radius: 6px;\r\n    }\r\n\r\n    .companies-list {\r\n      flex: 1;\r\n      overflow-y: auto;\r\n      margin: -8px; // Compensate for company-item margin\r\n\r\n      .no-companies {\r\n        text-align: center;\r\n        padding: 40px 20px;\r\n        color: #666;\r\n        font-size: 14px;\r\n      }\r\n\r\n      .company-item {\r\n        margin: 8px;\r\n        padding: 16px;\r\n        border: 1px solid #e0e0e0;\r\n        border-radius: 8px;\r\n        cursor: pointer;\r\n        transition: all 0.2s ease;\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n\r\n        &:hover {\r\n          border-color: #007bff;\r\n          background-color: #f8f9ff;\r\n          transform: translateY(-1px);\r\n          box-shadow: 0 2px 8px rgba(0, 123, 255, 0.15);\r\n        }\r\n\r\n        &:active {\r\n          transform: translateY(0);\r\n          box-shadow: 0 1px 4px rgba(0, 123, 255, 0.2);\r\n        }\r\n\r\n        .company-info {\r\n          flex: 1;\r\n\r\n          .company-name {\r\n            margin: 0 0 8px 0;\r\n            font-size: 16px;\r\n            font-weight: 600;\r\n            color: #333;\r\n            transition: color 0.2s ease;\r\n          }\r\n\r\n          .company-email {\r\n            margin: 0 0 4px 0;\r\n            font-size: 14px;\r\n            color: #666;\r\n          }\r\n\r\n          .contact-person {\r\n            margin: 0;\r\n            font-size: 13px;\r\n            color: #888;\r\n          }\r\n        }\r\n\r\n        &:hover .company-info .company-name {\r\n          color: #007bff;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Responsive design\r\n@media (max-width: 768px) {\r\n  .company-selection-modal {\r\n    width: 95%;\r\n    max-height: 85vh;\r\n\r\n    .modal-header {\r\n      padding: 16px 20px;\r\n\r\n      h2 {\r\n        font-size: 1.3rem;\r\n      }\r\n    }\r\n\r\n    .modal-body {\r\n      padding: 16px 20px;\r\n\r\n      .company-item {\r\n        padding: 16px;\r\n        margin: 6px;\r\n\r\n        .company-info {\r\n          .company-name {\r\n            font-size: 15px;\r\n          }\r\n\r\n          .company-email {\r\n            font-size: 13px;\r\n          }\r\n\r\n          .contact-person {\r\n            font-size: 12px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
